import { useRef, useState } from "react"
import { ModalTest } from "../../Modal"
import { ModalRefType } from "../../DesignSystem/Interfaces/Interfaces"
import { useSelector, useDispatch } from "react-redux"
import { IKeysModal, RootState } from "../../Interfaces";
import { useUpdateEffect } from "../../CustomHooks";
import { closeModal } from "../../Redux/Reducers/ModalReducer/ModalReducer";
function ModalProvider() {
    const { name, data } = useSelector((state: RootState) => state?.modal);
    const modalName = useRef("")
    const modalTestRef = useRef<ModalRefType>()
    const dispatch = useDispatch()

    const onExit = (key: string) => {
        switch (key) {
            case "modalTestRef":
                modalTestRef.current?.onClose()
                break;

            default:
                break;
        }
        dispatch(closeModal())
        modalName.current = ""
    }
    const onShow = (key: string) => {
        modalName.current = key
        switch (key) {
            case "modalTestRef":
                modalTestRef.current?.onOpen()
                break;

            default:
                break;
        }

    }
    useUpdateEffect(() => {
        if (name) {
            if (modalName.current === "") {
                onShow(name)
            }
        }
    }, [name])
    return <>
        <ModalTest
            ref={modalTestRef}
            data={data}
            onExit={() => onExit("modalTestRef")}
            onShow={() => onShow("modalTestRef")}
        />
    </>
}
export default ModalProvider